/**
 * Single source of truth for whether checklist template v2 (QA2) content should be used,
 * given the QA2 add-on state and the checklist templates a project already has.
 *
 * With the add-on active, only the "still purely on v1" case (v1 present, v2 absent) opts out
 * of v2. With the add-on inactive, the presence of v2 checklist templates alone decides whether
 * v2 is allowed - a project already migrated to v2 keeps working even after the add-on is
 * disabled again.
 *
 * Mirrors `shouldUseChecklistTemplatesV2` in
 * `web-apps/libs/shared/domain/src/lib/policies/checklist-template-version.policy.ts`.
 *
 * @param {boolean} isQa2AddonEnabled
 * @param {{ hasV1ChecklistTemplates: boolean, hasV2ChecklistTemplates: boolean }} availability
 * @returns {boolean}
 */
export function shouldUseChecklistTemplatesV2(
    isQa2AddonEnabled,
    { hasV1ChecklistTemplates, hasV2ChecklistTemplates }
) {
    return isQa2AddonEnabled
        ? !(hasV1ChecklistTemplates && !hasV2ChecklistTemplates)
        : hasV2ChecklistTemplates;
}
